import { Component, OnInit } from '@angular/core';
import { NgxSpinnerService } from 'ngx-spinner';
import {
  Language,
  getDirection,
  getFontClass,
  translations,
} from '../thi/thi-translations';
import { normalizeThiLang } from '../thi/thi-lang.util';

@Component({
  selector: 'app-about',
  templateUrl: './about.component.html',
  styleUrls: ['./about.component.scss'],
})
export class AboutComponent implements OnInit {
  curentLang = '';
  landingLang: Language = 'ar';
  dir: 'rtl' | 'ltr' = 'rtl';
  fontClass = 'font-cairo';
  t = translations.ar;

  readonly values: { icon: string; titleKey: 'value1' | 'value2' | 'value3' }[] = [
    { icon: 'fa fa-bullseye', titleKey: 'value1' },
    { icon: 'fa fa-lightbulb-o', titleKey: 'value2' },
    { icon: 'fa fa-eye', titleKey: 'value3' },
  ];

  constructor(private spinner: NgxSpinnerService) {
    this.curentLang = localStorage.getItem('curentLang') || 'ar';
  }

  ngOnInit(): void {
    this.landingLang = normalizeThiLang(this.curentLang);
    this.dir = getDirection(this.landingLang);
    this.fontClass = getFontClass(this.landingLang);
    this.t = translations[this.landingLang];
    this.spinner.show();
    setTimeout(() => this.spinner.hide(), 400);
  }

  get arrowIcon(): string {
    return this.dir === 'rtl' ? 'fa fa-arrow-left' : 'fa fa-arrow-right';
  }

  valueTitle(k: 'value1' | 'value2' | 'value3'): string {
    return (this.t.about as any)[k] as string;
  }

  valueDesc(k: 'value1' | 'value2' | 'value3'): string {
    return (this.t.about as any)[k + 'Desc'] as string;
  }
}
